import {
  GetEmailNotificationsRawResponse,
  GetEmailNotificationsResponse,
  UpdateEmailNotificationsRawResponse,
  UpdateEmailNotificationsResponse,
} from "./types";

export const transformGetEmailNotifications = (res: GetEmailNotificationsRawResponse) => {
  const { _links, ...notifications } = res;
  const response: GetEmailNotificationsResponse = {
    data: {
      details: {
        phoneDriverHotline: notifications.phone_driver_hotline,
        emailDriverHotline: notifications.email_driver_hotline,
        enabledBccAllEmails: Boolean(notifications.enabled_bcc_all_emails),
        emailAddressBccAll: notifications.email_address_bcc_all,
        enabledBookingNotifications: Boolean(notifications.enabled_booking_notifications),
        emailBookingNotifications: notifications.email_booking_notifications,
        enabledDriverNotifications: Boolean(notifications.enabled_driver_notifications),
        emailDriverNotifications: notifications.email_driver_notifications,
        enabledLowJobRatingNotifications: Boolean(notifications.enabled_low_job_rating_notifications),
        emailLowJobNotifications: notifications.email_low_job_notifications,
        enabledMemberRegistrationNotifications: Boolean(notifications.enabled_member_registration_notifications),
        emailMemberRegistrationNotifications: notifications.email_member_registration_notifications,
        enabledFailedPaymentNotifications: Boolean(notifications.enabled_failed_payment_notifications),
        emailFailedPaymentNotifications: notifications.email_failed_payment_notifications,
        emailQuoteNotifications: notifications.email_quote_notifications,
        enabledQuoteNotifications: Boolean(notifications.enabled_quote_notifications),
        enabledClientBookingNotifications: Boolean(notifications.enabled_client_booking_notifications),
        enabledClientOwnNotifications: Boolean(notifications.enabled_client_own_notifications),
        enabledClientGuestNotifications: Boolean(notifications.enabled_client_guest_notifications),
      },
    },
    links: _links,
  };

  return response;
};

export const transformUpdateEmailNotifications = (res: UpdateEmailNotificationsRawResponse) => {
  return {
    links: res._links,
  } as UpdateEmailNotificationsResponse;
};
